// QuestionCard.jsx
import BookmarkIcon from '@mui/icons-material/Bookmark';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function QuestionCard({ question, selected, onAnswer, onToggleReview }) {
    const handleClear = () => {
        onAnswer(question.id, null); // clear response
    };
    const showClear = selected !== null && selected !== "";

    return (
        <div style={styles.card}>
            {/* Header */}
            {/* Header */}
            <div style={styles.header}>
                <span style={styles.qNumber}>
                    Q{question.sequence}
                </span>
            </div>

            {/* Single Choice Questions */}
            {question.type === "SCQ" && (
                <div style={styles.optionsContainer}>
                    {question.options
                        .filter(Boolean)
                        .map((opt) => (
                            <label
                                key={opt}
                                style={{
                                    ...styles.option,
                                    background: selected === opt ? "#e3f2fd" : "#fafafa",
                                    borderColor: selected === opt ? "#1976d2" : "#ccc",
                                }}
                            >
                                <input
                                    type="radio"
                                    name={`q-${question.id}`}
                                    checked={selected === opt}
                                    onChange={() => onAnswer(question.id, opt)}
                                />
                                <span>{opt}</span>
                            </label>
                        ))}
                </div>
            )}

            {/* Numerical Question */}
            {question.type === "NUMERICAL" && (
                <input
                    type="number"
                    value={selected || ""}
                    onChange={(e) => onAnswer(question.id, e.target.value)}
                    style={styles.input}
                    placeholder="Enter answer"
                />
            )}
            {/* Clear Button */}
            {
                <RefreshIcon
                    disabled={!showClear}
                    onClick={showClear && handleClear}
                    style={{
                        ...styles.clearIcon,
                        color: showClear ? '#f44336' : '#808080',
                        cursor: showClear ? 'pointer' : 'not-allowed'
                    }}
                />
            }
            {/* Mark for Review */}
            <BookmarkIcon
                onClick={() => onToggleReview(question.id)}
                style={{
                    ...styles.flagIcon,
                    color: question.markForReview ? "#ff9800" : "#bbb",
                    cursor: "pointer",
                }}
            />
        </div>
    );
}

const styles = {
    card: {
        border: "1px solid #ddd",
        padding: 6,
        marginBottom: 2,
        borderRadius: 6,
        background: "#fff",
        position: "relative",
        display: 'flex'
    },
    header: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontWeight: "bold",
        // marginBottom: 10,
        marginRight: 10,
    },

    qNumber: {
        // background: "#1976d2",
        // color: "#fff",
        padding: "4px 8px",
        // borderRadius: 4,
        fontSize: 14,
    },

    // Horizontal container
    optionsContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
    },

    // Option button style
    option: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        border: "1px solid #ccc",
        padding: "6px 12px",
        borderRadius: 4,
        cursor: "pointer",
        userSelect: "none",
    },

    input: {
        width: "100%",
        padding: 8,
        borderRadius: 4,
        border: "1px solid #ccc",
    },
    clearBtn: {
        marginLeft: 12,
        // background: "#f44336",
        color: "#f44336",
        border: "none",
        // padding: "4px 10px",
        // borderRadius: 4,
        cursor: "pointer",
        fontSize: 12,
    },
    clearIcon: {
        position: "absolute",
        top: 8,
        right: 8,
        // color: "#f44336",
        // cursor: "pointer",
        fontSize: 20,
    },
    flagIcon: { position: "absolute", top: 8, right: 36 },
};